import React from "react"

import { Row, Col, Card } from "react-bootstrap"

function PropertyFeatures({ property }) {
    return (
        <>
            <Col xs={12} as={Card} className="mt-5 mt-md-7">
                {/* Property Features */}
                <Card.Body>
                    <Card.Title>
                        <h2 className="text-center">Key features</h2>
                    </Card.Title>
                </Card.Body>
            </Col>
            <Col xs={12} as={Card} className="mt-4">
                <Card.Body>
                    <Row>
                        {property.features.map((feature) => (
                            <Col
                                xs={12}
                                sm={6}
                                xxl={4}
                                key={feature.id}
                                className="list-pad"
                            >
                                <ul className="feature-tick">
                                    <li className="feature-tick">
                                        <span>{feature.description}</span>
                                    </li>
                                </ul>
                            </Col>
                        ))}
                    </Row>
                </Card.Body>
                {/* Property Features End */}
            </Col>
        </>
    )
}

export default PropertyFeatures
